<template>
    <div class="wallet-modal-backdrop" @click.self="$emit('close')">
        <div class="modal-card" role="dialog" :aria-label="$t('userWallet.stake.notice.title')">
            <div class="modal-header">
                <div class="modal-title-row">
                    <img src="/assets/images/wallets/aube.png" alt="" width="28" height="28">
                    <h2>{{ $t('userWallet.stake.notice.title') }}</h2>
                </div>
                <button class="icon-button" type="button" :aria-label="$t('userWallet.close')" @click="$emit('close')">
                    <img src="/assets/images/wallets/close.svg" alt="" width="22" height="22">
                </button>
            </div>

            <div class="modal-body">
                <p class="notice-text">{{ $t('userWallet.stake.notice.message1') }}</p>
                <p class="notice-text">{{ $t('userWallet.stake.notice.message2') }}</p>
            </div>

            <div class="modal-actions centered">
                <a class="primary-button" :href="applyUrl" target="_blank" rel="noopener noreferrer">
                    {{ $t('userWallet.stake.notice.applyLink') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'WalletStakeNoticeModal',

        data() {
            return {
                applyUrl: process.env.MIX_AUBE_COIN_STAKING_URL + '/send',
            };
        },
    };
</script>
